<template>
  <div class="topForm">
    <vxe-toolbar v-if="canEdit">
      <template v-slot:buttons>
        <vxe-button @click="addRow()" type="primary" class="vxe-btn-primary"
          ><svg-icon
            class="icon-img"
            style="font-size: 16px; padding-right: 6px"
            icon-class="icon-add"
          />新增</vxe-button
        >
        <vxe-button
          @click="deleteRow"
          size="medium"
          type="primary"
          icon="el-icon-delete"
          class="vxe-btn-delete"
          >删除</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-grid
      border
      show-overflow
      resizable
      ref="table"
      class="vxe-table-element"
      size="mini"
      align="left"
      :max-height="maxHeight"
      :auto-resize="true"
      :data="tableData"
      :columns="column"
      :edit-rules="rules"
      @edit-actived="editActivedEvent"
      :edit-config="canEdit ? { trigger: 'click', mode: 'row' } : null"
      :valid-config="{ autoPos: true, message: 'inline' }"
      show-footer
      :footer-method="footerMethod"
    >
    </vxe-grid>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import ajaxSelect from '@/components/form-item/ajax-select';
  // import inputNumber from '@/components/form-item/input-number';
  // import searchTable from '@/components/form-item/search-table';
  import API from '@/api/financeCenter/generalAccounting';

  export default {
    name: 'collarDetailsInfo',
    props: ['canEdit'],
    components: {
      // ajaxSelect,
      // inputNumber,
      // searchTable,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        maxHeight() {
          return window.innerHeight / 2 + 'px';
        },

        taxList() {
          let dictList = this.$baseRequest.getDictListMapByType('tax_rate');
          dictList = dictList.map((item) => {
            item.label = item.value;
            return item;
          });
          return dictList;
        },
      }),
      column() {
        return [
          { type: 'checkbox', width: 60 },
          { type: 'seq', field: 'sortNo', title: this.$t('glVoucher.table.sortNo'), width: 80 }, // 序号
          {
            field: 'natureSideCode',
            title: this.$t('glVoucher.table.natureSideCode'),
            width: 120, // 借贷方
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('natureSide'),
              props: { clearable: true },
              events: { change: this.natureSideChange },
            },
          },
          {
            field: 'pkCode',
            title: this.$t('glVoucher.table.pkCode'),
            width: 180, // 过账码
            editRender: { name: 'ElInput', props: { clearable: true, disabled: this.pkDisabled } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.pkCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <ajax-select
                    value={row.pkCode}
                    apiUrl={API.GET_SAPPK}
                    apiData={{ natureSideCode: row.natureSideCode }}
                    method="post"
                    valueKey="pkCode"
                    labelKey="pkCode"
                    moreShowKey="pkName"
                    disabled={this.pkDisabled}
                    onInput={(val) => this.chooseTable(val, row, 'pkCode')}
                  ></ajax-select>,
                ];
              },
            },
          },
          {
            field: 'sglCode',
            title: this.$t('glVoucher.table.sglCode'),
            width: 120, // 特别总账标识
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'negativeFlag',
            title: this.$t('glVoucher.table.negativeFlag'),
            width: 120, // 反记账标识
          },
          {
            field: 'accountType',
            title: this.$t('glVoucher.table.accountType'),
            width: 120, // 科目类型
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('accountType'),
              props: { clearable: true },
              events: { change: this.accountTypeChange },
            },
          },
          {
            field: 'accountCode',
            title: this.$t('glVoucher.table.accountCode'),
            width: 180, // 科目代码
            editRender: {
              name: 'ElInput',
              props: { clearable: true, disabled: this.accountDisabled },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row.accountCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType={this.searchType}
                    isMultiple={true}
                    currentValue={row.accountCode}
                    checkRowKeys={[row.accountCode]}
                    disabled={this.accountDisabled}
                    onInput={(val) => this.chooseTable(val, row, 'accountCode')}
                  />,
                ];
              },
            },
          },
          { field: 'accountDesc', title: this.$t('glVoucher.table.accountDesc'), width: 180 }, // 科目说明
          {
            field: 'enteredAmount',
            title: this.$t('glVoucher.table.enteredAmount'),
            width: 120, // 原币金额
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.enteredAmount)}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.enteredAmount}
                    max={999999999.99}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'enteredAmount')}
                  />,
                ];
              },
            },
          },
          {
            field: 'accountedAmount',
            title: this.$t('glVoucher.table.accountedAmount'),
            width: 100,
            slots: {
              // 使用 JSX 渲染
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.accountedAmount)}</span>];
              },
            },
          }, // 本币金额
          {
            field: 'profitCenterCode',
            title: this.$t('glVoucher.table.profitCenterCode'),
            width: 150, // 利润中心代码
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.profitCenterCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="sapProfitCenter"
                    isMultiple={true}
                    currentValue={row.profitCenterCode}
                    checkRowKeys={[row.profitCenterCode]}
                    onInput={(val) => this.chooseTable(val, row, 'profitCenterCode')}
                  />,
                ];
              },
            },
          },
          {
            field: 'profitCenterName',
            title: this.$t('glVoucher.table.profitCenterName'),
            width: 180,
          }, // 利润中心名称
          {
            field: 'costCenterCode',
            title: this.$t('glVoucher.table.costCenterCode'),
            width: 140, // 成本中心代码
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.costCenterCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="sapCostCenter"
                    isMultiple={true}
                    currentValue={row.costCenterCode}
                    checkRowKeys={[row.costCenterCode]}
                    onInput={(val) => this.chooseTable(val, row, 'costCenterCode')}
                  />,
                ];
              },
            },
          },
          { field: 'costCenterName', title: this.$t('glVoucher.table.costCenterName'), width: 180 }, // 成本中心名称
          {
            title: this.$t('glVoucher.table.cashflowTransactionCode'),
            field: 'cashflowTransactionCode',
            width: 150, // 现金流量事务代码
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.cashflowTransactionCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="cashflow"
                    isMultiple={true}
                    currentValue={row.cashflowTransactionCode}
                    checkRowKeys={[row.cashflowTransactionCode]}
                    onInput={(val) => this.chooseTable(val, row, 'cashflowTransactionCode')}
                  />,
                ];
              },
            },
          },
          {
            field: 'cashflowTransactionName',
            title: this.$t('glVoucher.table.cashflowTransactionName'),
            width: 150,
          }, // 现金流量事务名称
          {
            field: 'currencyCode',
            title: this.$t('glVoucher.table.currencyCode'),
            width: 120, // 币种
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('all_currency'),
              props: {
                clearable: true,
                disabled: true,
                placeholder: this.$t('glVoucher.placeholder.auto'),
              },
            },
          },
          { field: 'exchangeRate', title: this.$t('glVoucher.table.exchangeRate'), width: 100 }, // 汇率
          {
            field: 'summary',
            title: '文本',
            width: 150, // 文本
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'taxCode',
            title: this.$t('glVoucher.table.taxCode'),
            width: 150, // 税码
            editRender: { name: 'ElSelect', options: this.taxList, props: { clearable: true } },
          },
          {
            field: 'sapBankCode',
            title: this.$t('glVoucher.table.sapBankCode'),
            width: 100,
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.sapBankCode}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bankAccount"
                    isMultiple={true}
                    currentValue={row.sapBankCode}
                    onInput={(val) => this.chooseTable(val, row, 'sapBankCode')}
                  />,
                ];
              },
            },
          }, // SAP银行代码
          {
            field: 'bankAccountNum',
            title: this.$t('glVoucher.table.bankAccountNum'),
            width: 150, // 银行账户
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.bankAccountNum}</span>];
              },
              edit: ({ row }) => {
                return [
                  <search-table
                    searchType="bankAccount"
                    isMultiple={true}
                    currentValue={row.bankAccountNum}
                    checkRowKeys={[row.bankAccountNum]}
                    onInput={(val) => this.chooseTable(val, row, 'bankAccountNum')}
                  />,
                ];
              },
            },
          },
          /* { field: "bankName", title: this.$t("glVoucher.table.bankName"), width: 150 }, // 开户行名称
        { field: "customerCode", title: this.$t("glVoucher.table.customerCode"), width: 150, // 辅核-客户
          editRender: { name: "ElInput", props: { clearable: true } },
          slots: {
            default: ({ row }) => { return [<span>{row.customerCode}</span>]; },
            edit: ({ row }) => {
              return [
                <search-table
                  searchType="sapCustomer"
                  isMultiple={true}
                  currentValue={row.customerCode}
                  checkRowKeys={[row.customerCode]}
                  onInput={val => this.chooseTable(val, row, "customerCode")}
                />
              ];
            }
          }
        },
        { field: "supplierCode", title: this.$t("glVoucher.table.supplierCode"), width: 150, // 辅核-供应商
          editRender: { name: "ElInput", props: { clearable: true } },
          slots: {
            default: ({ row }) => { return [<span>{row.supplierCode}</span>]; },
            edit: ({ row }) => {
              return [
                <search-table
                  searchType="sapSupplier"
                  isMultiple={true}
                  currentValue={row.supplierCode}
                  checkRowKeys={[row.supplierCode]}
                  onInput={val => this.chooseTable(val, row, "supplierCode")}
                />
              ];
            }
          }
        },
        { field: "externalCustomerCode", title: this.$t("glVoucher.table.externalCustomerCode"), width: 150, // 外部客户
          editRender: { name: "ElSelect", options: this.$baseRequest.getDictListMapByType('externalCustomerCode'), props: { clearable: true } }
        }, */
          {
            field: 'maturityDate',
            title: this.$t('glVoucher.table.maturityDate'),
            width: 180, // 到期日
            editRender: {
              name: 'ElDatePicker',
              props: { clearable: true, valueFormat: 'yyyy-MM-dd' },
            },
          },
          {
            field: 'loanNature',
            title: this.$t('glVoucher.table.loanNature'),
            width: 100, // 借款性质
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('loanNature'),
              props: { clearable: true },
            },
          },
          {
            field: 'batchNo',
            title: this.$t('glVoucher.table.batchNo'),
            width: 120, // 批次/评估类型
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          /* { field: "materialCode", title: this.$t("glVoucher.table.materialCode"), width: 120, // 商品编号
        }, */

          {
            field: 'businessQuantity',
            title: this.$t('glVoucher.table.businessQuantity'),
            width: 120, // 数量
            editRender: { name: 'ElInput', props: { clearable: true } },
            slots: {
              default: ({ row }) => {
                return [<span>{row.businessQuantity}</span>];
              },
              edit: ({ row }) => {
                return [
                  <input-number
                    value={row.businessQuantity}
                    max={999999999}
                    min={0}
                    precision={this.$globalVar.qPiont}
                    onInput={(val) => this.chooseTable(val, row, 'businessQuantity')}
                  />,
                ];
              },
            },
          },
          {
            field: 'businessUnit',
            title: this.$t('glVoucher.table.businessUnit'),
            width: 120, // 单位
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'orderNo',
            title: this.$t('glVoucher.table.orderNo'),
            width: 120, // 采购订单号
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'orderDetailNo',
            title: this.$t('glVoucher.table.orderDetailNo'),
            width: 120, // 采购订单行号
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          /* { field: "salesOrderNo", title: this.$t("glVoucher.table.salesOrderNo"), width: 120, // 销售订单号
          editRender: { name: "ElInput", props: { clearable: true } }
        },
        { field: "salesOrderItem", title: this.$t("glVoucher.table.salesOrderItem"), width: 120, // 销售订单行号
          editRender: { name: "ElInput", props: { clearable: true } }
        },
        { field: "productCategory", title: this.$t("glVoucher.table.productCategory"), width: 120, // 商品分类
          editRender: { name: "ElInput", props: { clearable: true } }
        }, */
          {
            field: 'externalContractNo',
            title: this.$t('glVoucher.table.externalContractNo'),
            width: 120, // 外部合同号
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          /* { field: "invoiceNo", title: this.$t("glVoucher.table.invoiceNo"), width: 120, // 发票号
          editRender: { name: "ElInput", props: { clearable: true } }
        }, */

          {
            field: 'zzboeno',
            title: this.$t('glVoucher.table.zzboeno'),
            width: 120, // 物料号
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'contractNo',
            title: this.$t('glVoucher.table.contractNo'),
            width: 120, //代理合同号
          },
          /* { field: "baseQuantity", title: this.$t("glVoucher.table.baseQuantity"), width: 120, // 基本数量
        },
        { field: "baseUnit", title: this.$t("glVoucher.table.baseUnit"), width: 120, // 基本计量单位
        }, */
          {
            field: 'payCondition',
            title: this.$t('glVoucher.table.payCondition'),
            width: 120, // 付款条件代码
          },
          {
            field: 'paymentMethod',
            title: this.$t('glVoucher.table.paymentMethod'),
            width: 120, // 付款方式
          },
          /* { field: "plant", title: this.$t("glVoucher.table.plant"), width: 120, // 工厂
        }, */
          {
            field: 'assignmentNo',
            title: this.$t('glVoucher.table.assignmentNo'),
            width: 120, // 分配号
          },
          {
            field: 'refKey3',
            title: '参考码3',
            width: 120, // 参考码3
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'supplierCode',
            title: 'SAP供应商编码',
            width: 120, // SAP供应商编码
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'supplierCode',
            title: ' 辅助核算供应商',
            width: 120, // 辅助核算供应商
          },
          {
            field: 'customerCode',
            title: 'SAP客户编码',
            width: 120, // SAP客户编码
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
          {
            field: 'customerCode',
            title: '辅助核算客户',
            width: 120, // 辅助核算客户
          },

          {
            field: 'zzkunnrc',
            title: '外部客户编码',
            width: 120, // 特别总账标识
            editRender: { name: 'ElInput', props: { clearable: true } },
          },
        ];
      },
      rules() {
        return {
          natureSideCode: [
            // 借贷方
            {
              required: true,
              message: this.$t('glVoucher.placeholder.natureSideCode'),
              trigger: ['blur', 'change'],
            },
          ],
          pkCode: [
            // 过账码
            {
              required: true,
              message: this.$t('glVoucher.placeholder.pkCode'),
              trigger: ['blur', 'change'],
            },
          ],
          accountType: [
            // 科目类型
            {
              required: true,
              message: this.$t('glVoucher.placeholder.accountType'),
              trigger: ['blur', 'change'],
            },
          ],
          accountCode: [
            // 科目代码
            {
              required: true,
              message: this.$t('glVoucher.placeholder.accountCode'),
              trigger: ['blur', 'change'],
            },
          ],
          enteredAmount: [
            // 原币金额
            {
              required: true,
              message: this.$t('glVoucher.placeholder.enteredAmount'),
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
    },
    mounted() {
      if (!this.$route.query.id) {
        this.resolveTableData();
      }
    },
    data() {
      return {
        pkDisabled: true,
        accountDisabled: true,
        searchType: 'account',
        extraData: null,
        addRowObj: {
          natureSideCode: null, // 借贷方
          pkCode: null, // 过账码
          accountType: null, // 科目类型
          accountCode: null, // 科目代码
          accountDesc: null, // 科目说明
          enteredAmount: 0, // 原币金额
          accountedAmount: 0, // 本币金额
          profitCenterCode: null, // 利润中心代码
          profitCenterName: null, // 利润中心名称
          costCenterCode: null, // 成本中心代码
          costCenterName: null, // 成本中心名称
          cashflowTransactionCode: null, // 现金流量事务代码
          cashflowTransactionName: null, // 现金流量事务名称
          currencyCode: null, // 币种
          exchangeRate: null, // 汇率
          summary: null, // 文本
          sapBankCode: null, //SAP账号
          bankAccountNum: null, // 银行账户
          bankName: null, // 开户行名称
          partnerCode: null, // 合作伙伴编码
          partnerZhName: null, // 合作伙伴中文名称
          customerCode: null, // 辅核-客户
          supplierCode: null, // 辅核-供应商
          externalCustomerCode: null, // 外部客户
          maturityDate: null, // 到期日
          loanNature: null, // 借款性质
          batchNo: null, // 批次/评估类型
          businessQuantity: 0, // 数量
          businessUnit: null, // 单位
          orderNo: null, // 采购销售订单号
          orderDetailNo: null, // 采购销售订单行号
          productCategory: null, // 商品分类
          externalContractNo: null, // 外部合同号
          invoiceNo: null, // 发票号
          materialCode: null, // 商品编码
          sglCode: null, //'特别总账标识',
          negativeFlag: null, //'反记账标识'
          taxCode: null, //税码
          zzkunnrc: null, //外部客户编码
        },
        tableData: [],
      };
    },
    methods: {
      chooseTable(val, row, prop) {
        row[prop] = val;
        if (prop == 'accountCode') {
          // 科目代码
          let fooArr = [];
          if (['D', 'K'].indexOf(row.accountType) != -1) {
            fooArr = [
              { val: 'accountCode', getVal: 'sapPartnerCode' },
              { val: 'accountDesc', getVal: 'partnerZhName' },
            ];
          } else if (row.accountType == 'M') {
            fooArr = [
              { val: 'accountCode', getVal: 'parentProductNo' },
              { val: 'accountDesc', getVal: 'productChName' },
            ];
          } else {
            fooArr = [{ val: 'accountCode' }, { val: 'accountDesc' }];
          }
          this.searchTableChange(row, val, fooArr);
        } else if (prop == 'enteredAmount') {
          // 原币金额
          row.accountedAmount = this.calcLocalAmount(val, row.exchangeRate); // 本币
        } else if (prop == 'profitCenterCode' || prop == 'costCenterCode') {
          // 利润、成本中心代码
          let propName = prop.replace('Code', 'Name');
          this.searchTableChange(row, val, [{ val: prop }, { val: propName }]);
        } else if (prop == 'cashflowTransactionCode') {
          // 现金流量事务代码
          this.searchTableChange(row, val, [
            { val: 'cashflowTransactionCode', getVal: 'cashflowCode' },
            { val: 'cashflowTransactionName', getVal: 'cashflowName' },
          ]);
        } else if (prop == 'bankAccountNum') {
          // 银行账户
          this.searchTableChange(row, val, [
            { val: 'bankAccountNum' },
            { val: 'bankName', getVal: 'branchName' },
          ]);
        } else if (prop == 'customerCode') {
          // 辅核-客户
          this.searchTableChange(row, val, [{ val: 'customerCode', getVal: 'sapPartnerCode' }]);
        } else if (prop == 'supplierCode') {
          // 辅核-供应商
          this.searchTableChange(row, val, [{ val: 'supplierCode', getVal: 'sapPartnerCode' }]);
        } else if (prop == 'sapBankCode') {
          // 银行账户
          this.searchTableChange(row, val, [
            { val: 'sapBankCode', getVal: 'sapBankCode' },
            { val: 'bankAccountNum', getVal: 'sapBankAccountCode' },
          ]);
        }
        this.updateFooterEvent();
      },
      searchTableChange(row, val, fooArr) {
        if (val && val.length > 0) {
          fooArr.map((item) => {
            if (item.getVal) {
              row[item.val] = val[0][item.getVal];
            } else {
              row[item.val] = val[0][item.val];
            }
          });
        } else {
          fooArr.map((item) => {
            row[item.val] = null;
          });
        }
      },
      natureSideChange(val) {
        // 借贷方
        val.row.pkCode = null;
        this.pkDisabled = val.row.natureSideCode ? false : true;
      },
      accountTypeChange(val) {
        // 科目类型
        val.row.accountCode = null;
        val.row.accountDesc = null;
        this.accountDisabled = val.row.accountType ? false : true;
        this.getSearchType(val.row.accountType);
      },
      getSearchType(accountType) {
        if (accountType == 'D') {
          this.searchType = 'sapCustomer';
        } else if (accountType == 'K') {
          this.searchType = 'sapSupplier';
        } else if (accountType == 'M') {
          this.searchType = 'product';
        } else {
          this.searchType = 'account';
        }
      },
      footerMethod({ columns, data }) {
        // 合计
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return this.$t('glVoucher.table.totalD');
            }
            if (['enteredAmount', 'accountedAmount'].includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                if (data[i].natureSideCode == 'D') {
                  subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
                }
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
          columns.map((column, columnIndex) => {
            if (columnIndex === 1) {
              return this.$t('glVoucher.table.totalC');
            }
            if (['enteredAmount', 'accountedAmount'].includes(column.property)) {
              let subtrahend = 0;
              for (let i = 0; i < data.length; i++) {
                if (data[i].natureSideCode == 'C') {
                  subtrahend = this.$cal.calCommon(data[i][column.property], subtrahend, '+');
                }
              }
              return this.$baseRequest.formatTableColumn(subtrahend);
            }
            return null;
          }),
        ];
      },
      updateFooterEvent() {
        // 在值发生改变时更新表尾合计
        let xTable = this.$refs.table;
        xTable.updateFooter();
      },
      syncHeader(val) {
        // 同步凭证头信息
        let tableData = this.$refs.table.getTableData().fullData;
        tableData.map((item) => {
          item.currencyCode = val.currencyCode; // 币种代码
          item.exchangeRate = val.exchangeRate; // 汇率
          item.accountedAmount = this.calcLocalAmount(item.enteredAmount, val.exchangeRate); // 本币
          item.summary = val.summary;
        });
        this.addRowObj.currencyCode = val.currencyCode;
        this.addRowObj.exchangeRate = val.exchangeRate;
        this.addRowObj.summary = val.summary;
      },
      // 初始一行表格空数据
      resolveTableData() {
        for (var i = 0; i < 2; i++) {
          this.tableData.push({ ...this.addRowObj });
        }
      },
      addRow(row) {
        let record = { ...this.addRowObj };
        this.$refs.table.validate().then(() => {
          this.$refs.table.insertAt(record, row).then(({ row }) => {
            this.$refs.table.setActiveRow(row);
          });
        });
      },
      deleteRow() {
        const selectedList = this.$refs.table.getSelectRecords(); // 获取选中数据
        if (selectedList.length < 1) {
          return this.tips('noData', 'error');
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.table.removeSelecteds();
          })
          .catch(() => {
            this.tips('cancelled', 'info');
          });
      },
      editActivedEvent({ row }) {
        this.pkDisabled = row.natureSideCode ? false : true;
        this.accountDisabled = row.accountType ? false : true;
        this.getSearchType(row.accountType);
      },
      // 计算本币
      calcLocalAmount(originAmount, exchangeRate) {
        return this.$cal.calCommon(originAmount, exchangeRate, '*', 'amount');
      },
      exportChildData() {
        // 返回数据
        const tableData = this.$refs.table.getTableData().fullData;
        // 点击提交，走校验
        if (tableData.length == 0) {
          return {
            fundCollectionFirstClaimList: [],
          };
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              resolve(tableData);
            });
          });
        }
      },
      tips(info, type) {
        // 提示
        this.$message({
          showClose: true,
          message: this.$t(`glVoucher.message.${info}`),
          type: type,
        });
      },
    },
  };
</script>
